import React from 'react';
import { Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AdminLogin, PageContainer } from 'Components';

const { REACT_APP_ADMIN_COOKIE, REACT_APP_ADMIN_TOKEN } = process.env;

const Admin = () => {
  const adminCookie = Cookies.get(REACT_APP_ADMIN_COOKIE);

  if (!adminCookie || adminCookie !== REACT_APP_ADMIN_TOKEN) {
    return <AdminLogin />;
  }

  return (
    <PageContainer isAdmin>
      <Outlet />
    </PageContainer>
  );
};

export default Admin;
